export default __webpack_public_path__ + "static/media/vaccine.2d02d558.png";